const DEFAULT_QUIET_PERIOD_MS = 500;

const generateId = () => {
  return Math.random().toString(36).substring(2) + Date.now().toString(36);
};

export class PageLoadTracker {
  private id: string;
  private pathname: string;
  private isComplete: boolean;
  private inFlightCount: number;
  private quietTimer: ReturnType<typeof setTimeout> | null;
  private quietPeriodMs: number;

  constructor(quietPeriodMs = DEFAULT_QUIET_PERIOD_MS) {
    this.id = generateId();
    this.pathname =
      typeof window !== 'undefined' ? window.location.pathname : '';
    this.isComplete = false;
    this.inFlightCount = 0;
    this.quietTimer = null;
    this.quietPeriodMs = quietPeriodMs;
  }

  private reset(newPathname: string): void {
    if (this.quietTimer) {
      clearTimeout(this.quietTimer);
    }
    this.id = generateId();
    this.pathname = newPathname;
    this.isComplete = false;
    this.inFlightCount = 0;
    this.quietTimer = null;
  }

  onRequestStart(): void {
    if (
      typeof window !== 'undefined' &&
      window.location.pathname !== this.pathname
    ) {
      this.reset(window.location.pathname);
    }

    if (this.quietTimer) {
      clearTimeout(this.quietTimer);
      this.quietTimer = null;
    }
    this.inFlightCount++;
  }

  onRequestEnd(): void {
    this.inFlightCount--;

    if (this.inFlightCount === 0 && !this.isComplete) {
      this.quietTimer = setTimeout(() => {
        this.isComplete = true;
        this.quietTimer = null;
      }, this.quietPeriodMs);
    }
  }

  getPageLoadId(): string | null {
    return this.isComplete ? null : this.id;
  }

  getPath(): string {
    return typeof window !== 'undefined' ? window.location.pathname : '';
  }
}
